import * as React from 'react';
import Tooltip from 'rc-tooltip';

export interface OverlayProps {
  close: () => void;
}

interface Props {
  placement: 'topRight' | 'top';
  overlay?: React.ReactElement<OverlayProps>;
  content?: React.FC<OverlayProps>;
}

interface State {
  visible: boolean;
}

class SingleTooltip extends React.Component<Props, State> {
  state: State = { visible: false };

  private mounted: boolean = false;

  render() {
    const { children, placement } = this.props;

    if (__ISSERVER__) {
      return children;
    }

    return (
      <Tooltip
        trigger={['click']}
        onVisibleChange={this.toggle}
        visible={this.state.visible}
        overlay={this.getOverlay()}
        placement={placement}
      >
        {children}
      </Tooltip>
    );
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  private getOverlay() {
    const { overlay, content: Content } = this.props;
    if (overlay) {
      return React.cloneElement(overlay, {
        close: this.onClose,
      });
    }
    if (Content) {
      return <Content close={this.onClose} />;
    }

    return <div />;
  }

  private toggle = (visible?: boolean) => {
    if (!this.mounted) {
      return;
    }
    this.setState({ visible: !!visible });
  };

  private onClose = () => {
    this.toggle(false);
  };
}

export default SingleTooltip;
